import { render, staticRenderFns } from "./SecurityManagerHeader.vue?vue&type=template&id=672981b2&scoped=true&"
import script from "./SecurityManagerHeader.vue?vue&type=script&lang=js&"
export * from "./SecurityManagerHeader.vue?vue&type=script&lang=js&"
import style0 from "./SecurityManagerHeader.vue?vue&type=style&index=0&id=672981b2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672981b2",
  null
  
)

export default component.exports